import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/app/layouts/login.vue").then(m => m.default || m))
}